'use client';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import CCHero from '@/components/CCHero';
import CCElement1 from '@/components/CCElement1';
import CCElement2 from '@/components/CCElement2';
import FAQSection from '@/components/FAQSection';
import Gallery from '@/components/Gallery';
import { galleryImages } from '@/data/galleryImages';
import { cleanerCareFaqs } from '@/data/faqData';

const CleanerCarePage = () => {
  return (
    <>
      <Header />
      <div className="header-gap-creator"></div>
      <main>
        <Breadcrumbs items={[{ label: 'Cleaner & Care' }]} />
        <div className="container-0">
          <CCHero />
          <CCElement1 />
          <CCElement2 />
          <FAQSection
            faqs={cleanerCareFaqs}
            title="FAQs About Air Filter Cleaner and Oil"
          />
          <Gallery gallery={galleryImages} />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default CleanerCarePage;
